export default __webpack_public_path__ + "static/multichain-2cd59972932f485fa7406ff5bb3f79b3.jpg";